// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_wHp9k {
  z-index: 999;
}
.bg_srZtO {
  background-color: var(--_00000033-shadow);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
}

.moveToFolder_Q2xB3 {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--white-color);
}
.statusMessage_WUEHu {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  border-radius: 5px;
  font-size: 16px;
  color: var(--white-background);
  z-index: 1000;
  transform: translate(-50%, -50%) scale(1);
  -webkit-transform: translate(-50%, -50%) scale(1);
  -moz-transform: translate(-50%, -50%) scale(1);
  -ms-transform: translate(-50%, -50%) scale(1);
  -o-transform: translate(-50%, -50%) scale(1);
  animation: scaleUp_FcPof 300ms ease-out forwards;
  @media (width<768px) {
    height: 100vh;
    box-sizing: border-box;
    width: 100vw;
    max-width: 100vw;
  }
}
.success_iNFsU {
  background-color: var(--f5-background);
  color: black;

  > div {
    padding: 10px;
  }
}
.contentInput_nAH6K {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  @media (width<768px) {
    height: 90%;
    box-sizing: border-box;
    justify-content: center;
  }
  > div {
    margin: 0 auto;
    width: 90%;
    background-color: var(--white-color);
    padding: 20px;
    gap: 20px;
    display: flex;
    flex-direction: column;
    border-radius: 14px;
    -webkit-border-radius: 14px;
    -moz-border-radius: 14px;
    -ms-border-radius: 14px;
    -o-border-radius: 14px;
  }
}
.titleContentInput_sloJ5 {
  color: #18181b;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 8px;
}

.scaleDown_zK5Gx {
  animation: scaleDown_zK5Gx 300ms ease-in forwards;
  -webkit-animation: scaleDown_zK5Gx 300ms ease-in forwards;
}

@keyframes scaleUp_FcPof {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_zK5Gx {
  from {
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_xyZTR {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/MoveToFolder/MoveToFolder.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,aAAa;EAKb,yCAAyC;EACzC,iDAAiD;EACjD,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C,gDAA0C;EAC1C;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,sCAAsC;EACtC,YAAY;;EAEZ;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,UAAU;IACV,oCAAoC;IACpC,aAAa;IACb,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".overlay {\n  z-index: 999;\n}\n.bg {\n  background-color: var(--_00000033-shadow);\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.moveToFolder {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--white-color);\n}\n.statusMessage {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  box-sizing: border-box;\n  border-radius: 5px;\n  font-size: 16px;\n  color: var(--white-background);\n  z-index: 1000;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%) scale(1);\n  -webkit-transform: translate(-50%, -50%) scale(1);\n  -moz-transform: translate(-50%, -50%) scale(1);\n  -ms-transform: translate(-50%, -50%) scale(1);\n  -o-transform: translate(-50%, -50%) scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  @media (width<768px) {\n    height: 100vh;\n    box-sizing: border-box;\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n.success {\n  background-color: var(--f5-background);\n  color: black;\n\n  > div {\n    padding: 10px;\n  }\n}\n.contentInput {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n  @media (width<768px) {\n    height: 90%;\n    box-sizing: border-box;\n    justify-content: center;\n  }\n  > div {\n    margin: 0 auto;\n    width: 90%;\n    background-color: var(--white-color);\n    padding: 20px;\n    gap: 20px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 14px;\n    -webkit-border-radius: 14px;\n    -moz-border-radius: 14px;\n    -ms-border-radius: 14px;\n    -o-border-radius: 14px;\n  }\n}\n.titleContentInput {\n  color: #18181b;\n  line-height: 1;\n  margin-top: 15px;\n  margin-bottom: 8px;\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_wHp9k`,
	"bg": `bg_srZtO`,
	"moveToFolder": `moveToFolder_Q2xB3`,
	"statusMessage": `statusMessage_WUEHu`,
	"scaleUp": `scaleUp_FcPof`,
	"success": `success_iNFsU`,
	"contentInput": `contentInput_nAH6K`,
	"titleContentInput": `titleContentInput_sloJ5`,
	"scaleDown": `scaleDown_zK5Gx`,
	"fadeOut": `fadeOut_xyZTR`
};
export default ___CSS_LOADER_EXPORT___;
